<div class="card kpi-blue-dark">
    <div class="card-body kpi-card">
        <h5 class="card-title">Travaux au m²</h5>
        <p class="card-value">
            <ng-container *ngIf="preview">- €/m²</ng-container>
            <ng-container *ngIf="!preview">
                {{ favorite.works_total + favorite.other_fees_work  / favorite.square  | number:'1.0-0'  }} €/m²
            </ng-container>
        </p>
    </div>
</div>
